import { fightFlowMeta, type FightFlowKind } from './fightScreenFlow'

type Props = {
  kind: FightFlowKind
  playerName: string
  enemyName: string
  arenaName: string
}

export function FightFlowOverlay({ kind, playerName, enemyName, arenaName }: Props) {
  const meta = fightFlowMeta(kind)
  return (
    <section
      className={`fight-flow-transition fight-flow-transition--${kind}`}
      data-testid="fight-flow-transition"
      data-transition={kind}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="fight-flow-transition__scan" />
      <div className="fight-flow-transition__frame">
        <span className="fight-flow-transition__eyebrow">{meta.eyebrow}</span>
        <h2>{meta.title}</h2>
        <p>{meta.detail}</p>
        <div className="fight-flow-transition__versus" aria-hidden="true">
          <strong>{playerName}</strong>
          <i>VS</i>
          <strong>{enemyName}</strong>
        </div>
        <div className="fight-flow-transition__arena">
          <span>ARENA LINK</span>
          <strong>{arenaName}</strong>
        </div>
        <div className="fight-flow-transition__pulse" aria-hidden="true">
          <i /><i /><i /><i /><i /><i />
        </div>
        <small>GPU + PRESENTATION + INPUT GATE</small>
      </div>
    </section>
  )
}

